// Realistic hand-painted brush stroke in vibrant sunset colours.
// Ragged, painterly edges via turbulence displacement + a bristle texture overlay.
export const PaintStroke = ({ className = "", id = "ps" }) => {
  const grad = `${id}-grad`;
  const rough = `${id}-rough`;
  const bristle = `${id}-bristle`;
  const d =
    "M12 50 C90 33 220 29 340 36 C440 42 540 33 588 45 C567 61 470 67 350 62 C240 58 120 67 20 58 C8 56 6 53 12 50 Z";

  return (
    <svg
      className={className}
      viewBox="0 0 600 90"
      preserveAspectRatio="none"
      fill="none"
      aria-hidden
      data-testid="paint-stroke"
    >
      <defs>
        <linearGradient id={grad} x1="0" y1="0" x2="1" y2="0.4">
          <stop offset="0%" stopColor="#FFC24B" />
          <stop offset="26%" stopColor="#FF7A18" />
          <stop offset="52%" stopColor="#FF3D3D" />
          <stop offset="76%" stopColor="#FF2D7E" />
          <stop offset="100%" stopColor="#DA1E8F" />
        </linearGradient>

        <filter id={rough} x="-8%" y="-45%" width="116%" height="190%">
          <feTurbulence type="fractalNoise" baseFrequency="0.014 0.11" numOctaves="2" seed="7" result="n" />
          <feDisplacementMap in="SourceGraphic" in2="n" scale="24" xChannelSelector="R" yChannelSelector="G" />
        </filter>

        <filter id={bristle} x="0%" y="0%" width="100%" height="100%">
          <feTurbulence type="fractalNoise" baseFrequency="0.75 0.012" numOctaves="3" seed="4" result="b" />
          <feColorMatrix
            in="b"
            type="matrix"
            values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.85 0"
            result="ba"
          />
          <feComposite in="ba" in2="SourceGraphic" operator="in" />
        </filter>
      </defs>

      <g filter={`url(#${rough})`}>
        <path d={d} fill={`url(#${grad})`} />
        {/* bristle streaks for painterly texture */}
        <path d={d} fill="#5c0a24" opacity="0.4" filter={`url(#${bristle})`} />
      </g>
    </svg>
  );
};
